export enum AuthenticationActions {
  changeComponentStateAction = 'changeComponentStateAction',
  loginAction = 'loginAction',
  registerAdminAction = 'registerAdminAction',
  forgotPasswordAction = 'forgotPasswordAction',
  setPasswordAction = 'setPasswordAction',
  logoutAction = 'logoutAction',
  resetPasswordAction = 'resetPasswordAction',
  acceptTermsAction = 'acceptTermsAction',
  tagMatchAction = 'tagMatchAction',
  tagResetMatchAction = 'tagResetMatchAction',
  changePasswordAction = 'changePasswordAction',
  registerVeterinarianAction = 'registerVeterinarianAction',
  authenticateOwner = 'authenticateOwnerAction',
  resetOwnerAuthentication = 'resetOwnerAuthenticationAction',
  refreshTokenAction = 'refreshTokenAction',
  _revokeRefreshTokenAction = '_revokeRefreshTokenAction',
  requestChangeEmailAction = 'requestChangeEmailAction',
  confirmChangeEmailAction = 'confirmChangeEmailAction',
  customerLoginTokenRequestAction = 'customerLoginTokenRequestAction'
}

export enum VeterinarianActions {
  getVeterinarianOfficesAction = 'getVeterinarianOfficesAction',
  getVeterinarianOfficeByIdAction = 'getVeterinarianOfficeByIdAction',
  editVeterinarianOfficeAction = 'editVeterinarianOfficeAction',
  createVeterinarianOfficeAction = 'createVeterinarianOfficeAction',
  deleteVeterinarianOfficeAction = 'deleteVeterinarianOfficeAction',
  setSelectedVeterinarianOfficeIdAction = 'setSelectedVeterinarianOfficeIdAction',
  setSelectedVeterinarianUserIdAction = 'setSelectedVeterinarianUserIdAction',
  getAllUsersForOfficeAction = 'getAllUsersForOfficeAction',
  resetStateAction = 'resetStateAction',
  resetVeterinarianOfficeUsers = 'resetVeterinarianOfficeUsersAction',
  newVeterinarianOfficeAction = 'newVeterinarianOfficeAction'
}

export enum VeterinarianOfficeUsersActions {
  getByIdAction = 'getByIdAction',
  updateVeterinarianOfficeUserAction = 'updateVeterinarianOfficeUserAction',
  lockoutVeterinarianOfficeUserAction = 'lockoutVeterinarianOfficeUserAction',
  unlockVeterinarianOfficeUserAction = 'unlockVeterinarianOfficeUserAction',
  resetStateAction = 'resetStateAction'
}

export enum CustomersActions {
  getAllCustomersAction = 'getAllCustomersAction',
  resetStateAction = 'resetStateAction',
  getCustomerByIdAction = 'getCustomerByIdAction',
  registerCustomerAction = 'registerCustomerAction',
  updateCustomerAction = 'updateCustomerAction',
  getCustomerByEmailAction = 'getCustomerByEmailAction',
  setPublicCustomerAction = 'setPublicCustomerAction',
  clearCurrentCustomerAction = 'clearCurrentCustomerAction',
  registerCustomerIfNeededAction = 'registerCustomerIfNeededAction'
}

export enum AdminUserActions {
  getAllAdminUsersAction = 'getAllAdminUsersAction',
  resetStateAction = 'resetStateAction',
  getAdminUserByIdAction = 'getAdminUserByIdAction',
  lockAdminUserAction = 'lockAdminUserAction',
  unlockAdminUserAction = 'unlockAdminUserAction'
}

export enum RegisteredTagActions {
  resetStateAction = 'resetStateAction',
  getTagByIdAction = 'getTagByIdAction',
  getTagByCodeAction = 'getTagByCodeAction',
  getAllTagsAction = 'getAllTagsAction',
  getAllTagsByVeterinarianOfficeIdAction = 'getAllTagsByVeterinarianOfficeIdAction',
  addNewTagAction = 'addNewTagAction',
  isTagRegisteredAction = 'isTagRegisteredAction',
  setPublicPreRegisteredTagAction = 'setPublicPreRegisteredTagAction',
  updateTagAction = 'updateTagAction',
  resetCurrentTagAction = 'resetCurrentTagAction',
  orderDetailsAction = 'orderDetailsAction'
}

export enum ReportActions {
  getVeterinarianBillingReport = 'getVeterinarianBillingReportAction'
}
